import {
	isDesktop,
	isMobile,
	isIOS,
	isAndroid,
} from "shared/util/EnvironmentHelpers";
import isApp from "shared/util/isApp";

export const PLATFORM = {
	Desktop: "DESKTOP",
	Mobile: "MOBILE_SITE",
	iOS: "IOS_APP",
	Android: "ANDROID_APP",
	Unknown: "UNKNOWN",
};

function getPlatform() {
	if (isApp()) {
		if (isAndroid) {
			return PLATFORM.Android;
		} else if (isIOS) {
			return PLATFORM.iOS;
		}
	} else if (isDesktop) {
		return PLATFORM.Desktop;
	} else if (isMobile) {
		return PLATFORM.Mobile;
	}

	return PLATFORM.Unknown;
}

export default getPlatform;



// WEBPACK FOOTER //
// ./src/shared/util/getPlatform.js